import { inject, Injectable } from "@angular/core";
import { DbService } from "./db.service";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuditService {
  private db = inject(DbService);
  private authService = inject(AuthService);

  constructor() { }

  getStoreAudit = async (referenceNumber: string, storeId: string) => {
    const currentUser = await this.authService.getCurrentUser();

    return await this.db.get(
      `stores/${currentUser}/${referenceNumber}/${storeId}`,
      true,
    );
  };

  getStoreDraftAudit = async (referenceNumber: string, storeId: string) => {
    const currentUser = await this.authService.getCurrentUser();

    return await this.db.get(
      `drafts/${currentUser}/${referenceNumber}/${storeId}`,
      true,
    );
  };

  getAttachment = async (docId: string, filename: string, rev: string) => {
    return await this.db.getAttachment(docId, filename, rev);
  };

  saveCurrentStoreAudit = async (store: any) => {
    const currentUser = await this.authService.getCurrentUser();

    return await this.db.upsert(
      `stores/${currentUser}/${store.referenceNumber}/${store.storeId}`,
      store,
    );
  };

  saveAttachment = async (doc: any) => {
    return await this.db.put(doc);
  };
}
